import {RECEIVE_FETCHING} from "./types";

export function receiveFetching(payload) {
    return {
        type: RECEIVE_FETCHING,
        payload
    }
}